export default function Card(theme) {
    return {
        MuiCard: {
            styleOverrides: {
                root: {
                    position: 'relative',
                    boxShadow: theme.customShadows.card,
                    borderRadius: theme.radius(2),
                    zIndex: 0
                }
            }
        },
        MuiCardHeader: {
            defaultProps: {
                slotProps: {
                    title: {
                        variant: 'h6'
                    },
                    subheader: {
                        variant: 'body2',
                        marginTop: theme.spacing(0.5)
                    }
                }
            },
            styleOverrides: {
                root: {
                    padding: theme.spacing(3, 3, 0)
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(3)
                }
            }
        }
    };
}
